import { render } from "./teamLessonCreate.vue?vue&type=template&id=2ebdf952&scoped=true"
import script from "./teamLessonCreate.vue?vue&type=script&lang=js"
export * from "./teamLessonCreate.vue?vue&type=script&lang=js"

import "./teamLessonCreate.vue?vue&type=style&index=0&id=2ebdf952&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebdf952"]])

export default __exports__